import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { ApErrorHandler } from 'webcommon/common-api';
import { ApComplexModal } from 'webcommon/core-ui';
import {
  FindControlColumnConfigItemDto,
  FindControlColumnsConfigDto,
  FindControlUIBehaviorDto,
  FindControlUserColumnConfigItemDto,
  FindControlUserColumnsConfigDto,
} from 'webcommon/shared';

interface ReorderColumn {
  Name: string;
  Visible: boolean;
  Source: FindControlColumnConfigItemDto<unknown>;
}

@Component({
  selector: 'ap-findcontrol-reorder-columns-modal',
  styleUrls: [ './ap-findcontrol-reorder-columns-modal.component.less' ],
  templateUrl: './ap-findcontrol-reorder-columns-modal.component.html',
})
export class ApFindControlReorderColumnsModalComponent extends ApComplexModal<FindControlUserColumnsConfigDto> implements OnInit {
  @Input() findControlBehavior: FindControlUIBehaviorDto;

  @ViewChild('table') table: MatTable<ReorderColumn>;

  allVisible = false;
  columnList: ReorderColumn[] = [];
  displayedColumns: string[] = [
    'position',
    'Visible',
    'Name',
  ];

  constructor(
    elementInjector: Injector,
    private readonly apErrorHandler: ApErrorHandler,
  ) {
    super(elementInjector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.createColumnList(this.findControlBehavior.ColumnsConfig);
  }

  private createColumnList(columnsConfig: FindControlColumnsConfigDto) {
    const defaultColumnByName = new Map<string, FindControlColumnConfigItemDto<unknown>>();
    if (this.findControlBehavior.DefaultColumnsConfig?.Columns) {
      this.findControlBehavior.DefaultColumnsConfig.Columns.forEach(x => {
        if (!defaultColumnByName.get(x.ColumnName)) {
          defaultColumnByName.set(x.ColumnName, x);
        } else {
          const message = `Invalid configuration for find control: '${this.findControlBehavior.Id}', duplicate column: '${x.ColumnName}'`;
          console.error(message);
          this.apErrorHandler.reportBackgroundError(new Error(message));
        }
      });
    }
    this.columnList = columnsConfig.Columns.map(x => {
      const defaultColumn = defaultColumnByName.get(x.ColumnName);
      const defaultVisible = defaultColumn && defaultColumn.Visible;
      return {
        Name: defaultVisible ? x.ColumnDisplayName : `(${x.ColumnDisplayName})`,
        Visible: !!x.Visible,
        Source: x,
      };
    });
    this.onColumnVisibleChange();
  }

  onReset() {
    this.createColumnList(this.findControlBehavior.DefaultColumnsConfig);
  }

  reorderedRow(event: CdkDragDrop<ReorderColumn[]>) {
    moveItemInArray(this.columnList, event.previousIndex, event.currentIndex);
    this.table.renderRows();
  }

  onAllVisibleChange() {
    this.columnList.forEach(x => x.Visible = this.allVisible);
  }

  onColumnVisibleChange() {
    this.allVisible = this.columnList.every(x => x.Visible);
  }

  cancel() {
    this.apUserCancel();
  }

  close() {
    const newColumns = this.columnList.map(x => {
      const newColumn: FindControlUserColumnConfigItemDto = {
        ColumnName: x.Source.ColumnName,
        Hidden: !x.Visible,
      };
      return newColumn;
    });
    const newConfig: FindControlUserColumnsConfigDto = {
      Columns: newColumns,
    };
    this.apClose(newConfig);
  }
}
